(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexible-banner"] && !Shopify.designMode) return;
  try {
    
  // Sticky Nav
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header-wrapper');
    let lastScrollPosition = window.pageYOffset;
    const scrollThreshold = 300;
    
    window.addEventListener('scroll', function() {
      const currentScrollPosition = window.pageYOffset;
      
      if (currentScrollPosition > scrollThreshold) {
        if (currentScrollPosition < lastScrollPosition) {
          header.classList.add('show-nav');
        } else {
          header.classList.remove('show-nav');
        }
      } else {
        header.classList.remove('show-nav');
      }
      
      lastScrollPosition = currentScrollPosition;
    });
  });
  
  // Parallax Background
  document.addEventListener('DOMContentLoaded', function() {
    const parallaxElement = document.querySelector('.banner-container.parallax');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.boundingClientRect.bottom <= window.innerHeight) {
          parallaxElement.classList.add('parallax-visible');
        } else {
          parallaxElement.classList.remove('parallax-visible');
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });
    if (parallaxElement) {
      observer.observe(parallaxElement);
    }
  });

  // Parallax Content
  document.addEventListener('DOMContentLoaded', function() {
    const parallaxContents = document.querySelectorAll('.banner-content-parallax');
    
    if (parallaxContents.length > 0) {
      parallaxContents.forEach(wrapper => {
        let isFixed = false;
        const content = wrapper.querySelector('.banner-content');
        
        window.addEventListener('scroll', () => {
          const rect = wrapper.getBoundingClientRect();
          
          if (rect.top <= 0 && !isFixed) {
            wrapper.classList.add('is-visible');
            isFixed = true;
          } 
          else if (rect.top > 0 && isFixed) {
            wrapper.classList.remove('is-visible');
            isFixed = false;
          }
        });
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const richTextElements = document.querySelectorAll('.rich-text');
  
    richTextElements.forEach(function (element) {
      element.innerHTML = element.innerHTML.replace(/\^([\d,\-&\s]+)/g, '<span class="custom-sup">$1</span>');
    });
  });


  // Add tablet support detection and fallbacks
  document.addEventListener('DOMContentLoaded', function() {
    // Check for tablet images and apply fallback classes if needed
    const bannerMediaContainers = document.querySelectorAll('.banner-media');
    
    bannerMediaContainers.forEach(container => {
      const hasTabletImage = container.querySelector('.is-tablet');
      if (!hasTabletImage) {
        container.classList.add('no-tablet-image');
      }
    });
    
    // Handle responsive media selection for browsers without :has() support
    function updateResponsiveMedia() {
      const width = window.innerWidth;
      
      bannerMediaContainers.forEach(container => {
        const desktopMedia = container.querySelector('.is-desktop');
        const tabletMedia = container.querySelector('.is-tablet');
        const mobileMedia = container.querySelector('.is-mobile');
        
        // Hide all media first
        if (desktopMedia) desktopMedia.style.display = 'none';
        if (tabletMedia) tabletMedia.style.display = 'none';
        if (mobileMedia) mobileMedia.style.display = 'none';
        
        // Show appropriate media based on viewport width
        if (width >= 900) {
          if (desktopMedia) desktopMedia.style.display = 'block';
        } else if (width >= 768 && width < 900) {
          if (tabletMedia) {
            tabletMedia.style.display = 'block';
          } else if (desktopMedia) {
            desktopMedia.style.display = 'block';
          }
        } else {
          if (mobileMedia) {
            mobileMedia.style.display = 'block';
          } else if (tabletMedia) {
            tabletMedia.style.display = 'block';
          } else if (desktopMedia) {
            desktopMedia.style.display = 'block';
          }
        }
      });
    }
    
    // Check if browser supports :has() selector
    const supportsHas = (function() {
      try {
        document.querySelector(':has(*)');
        return true;
      } catch (e) {
        return false;
      }
    })();
    
    // If browser doesn't support :has(), use JavaScript fallback
    if (!supportsHas) {
      updateResponsiveMedia();
      window.addEventListener('resize', updateResponsiveMedia);
    }
  });


  /* ---------- Lazy-hydrate banner media + iOS inline autoplay + spinner ---------- */
  (function () {
    const root = document.getElementById('shopify-section-{{ section.id }}');
    if (!root) return;

    // IMPORTANT: Only target elements within THIS specific section
    const scope = root.querySelector('.flexible-banner');
    if (!scope) return;
    
    const scrollRoot = null; // hero scrolls with page, no separate scroller

    const videos  = Array.from(scope.querySelectorAll('.banner-media video'));
    const imgs    = Array.from(scope.querySelectorAll('.banner-media img'));
    const pictures = Array.from(scope.querySelectorAll('.banner-media picture'));
    const iframes = Array.from(scope.querySelectorAll('.banner-media iframe'));

    function inViewport(el) {
      const r = el.getBoundingClientRect();
      const h = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.top < h;
    }

    // ===== Spinner helpers (per media container) =====
    function getMediaContainer(el) {
      return el.closest('.banner-media') || el.parentElement || scope;
    }
    function ensureLoader(el) {
      const container = getMediaContainer(el);
      if (!container) return null;
      let loader = container.querySelector(':scope > .media-loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'media-loader is-hidden';
        loader.setAttribute('role', 'status');
        loader.setAttribute('aria-live', 'polite');
        const sr = document.createElement('span');
        sr.className = 'sr-only';
        sr.textContent = 'Loading…';
        loader.appendChild(sr);
        container.appendChild(loader);
      }
      return loader;
    }
    function showLoader(el) {
      const loader = ensureLoader(el);
      if (loader) loader.classList.remove('is-hidden');
    }
    function hideLoader(el) {
      const container = getMediaContainer(el);
      if (!container) return;
      const loader = container.querySelector(':scope > .media-loader');
      if (loader) loader.classList.add('is-hidden');
    }

    function ensureVideoFlags(v) {
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('muted', '');
      v.setAttribute('autoplay', '');
      v.removeAttribute('controls');

      v.playsInline  = true;
      v.muted        = true;
      v.defaultMuted = true;
      v.autoplay     = true;
    }

    function wantsAutoplay(v) {
      const d = v.dataset.autoplay;
      return v.hasAttribute('autoplay') || d === 'true' || d === '1';
    }

    function deferImg(img) {
      if (!img || img.dataset.lazyified === '1') return;
      const picture = img.closest('picture');
      if (picture && picture.classList.contains('priority-image')) return;
      
      if (!img.getAttribute('width') && img.naturalWidth) img.setAttribute('width', img.naturalWidth);
      if (!img.getAttribute('height') && img.naturalHeight) img.setAttribute('height', img.naturalHeight);
      if (img.src)    { img.dataset.src = img.src; img.removeAttribute('src'); }
      if (img.srcset) { img.dataset.srcset = img.srcset; img.removeAttribute('srcset'); }
      img.loading = 'lazy';
      img.decoding = 'async';
      img.dataset.lazyified = '1';
    }

    function deferIframe(f) {
      if (!f || f.dataset.lazyified === '1') return;
      if (f.src) { f.dataset.src = f.src; f.removeAttribute('src'); }
      f.loading = 'lazy';
      f.dataset.lazyified = '1';
    }

    function deferVideo(v) {
      if (!v || v.dataset.lazyified === '1' || v.classList.contains('priority-video')) return;
      ensureVideoFlags(v);
      v.dataset.wantsAutoplay = wantsAutoplay(v) ? '1' : '0';
      v.preload = 'none';
      v.querySelectorAll('source').forEach(s => {
        if (s.dataset.src || !s.src) return;
        s.dataset.src = s.src;
        s.removeAttribute('src');
      });
      v.dataset.lazyified = '1';
    }

    imgs.forEach(el => { 
      if (!inViewport(el)) {
        const picture = el.closest('picture');
        if (!picture || !picture.classList.contains('priority-image')) {
          deferImg(el);
        }
      }
    });
    iframes.forEach(el => { if (!inViewport(el)) deferIframe(el); });
    videos.forEach(v => {
      if (!v.classList.contains('priority-video')) {
        ensureVideoFlags(v);
        if (!inViewport(v)) deferVideo(v);
        else v.dataset.deferred = '0';
      }
    });

    function hydrateOnceVideo(v) {
      if (v.dataset.hydrated === '1') return;
      v.querySelectorAll('source').forEach(s => {
        if (!s.getAttribute('src') && s.dataset.src) s.setAttribute('src', s.dataset.src);
      });
      ensureVideoFlags(v);
      v.preload = 'auto';
      v.load();
      v.dataset.hydrated = '1';
    }

    function tryPlay(v) {
      if (v.dataset.wantsAutoplay !== '1') return;
      v.removeAttribute('poster');
      const p = v.play && v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => { /* Possibly blocked (e.g., Low Power Mode) */ });
      }
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;

        if (el.tagName === 'IMG') {
          if (!(el.complete && el.naturalWidth > 0)) {
            showLoader(el);
          }
          if (!el.getAttribute('src') && el.dataset.src) el.setAttribute('src', el.dataset.src);
          if (!el.getAttribute('srcset') && el.dataset.srcset) el.setAttribute('srcset', el.dataset.srcset);

          const onDone = () => hideLoader(el);
          if (el.complete && el.naturalWidth > 0) {
            onDone();
          } else {
            el.addEventListener('load', onDone, { once: true });
            el.addEventListener('error', onDone, { once: true });
          }
          io.unobserve(el);

        } else if (el.tagName === 'IFRAME') {
          showLoader(el);
          if (!el.getAttribute('src') && el.dataset.src) el.setAttribute('src', el.dataset.src);
          const onDone = () => hideLoader(el);
          el.addEventListener('load', onDone, { once: true });
          el.addEventListener('error', onDone, { once: true });
          io.unobserve(el);

        } else if (el.tagName === 'VIDEO') {
          showLoader(el);
          hydrateOnceVideo(el);

          const onReady = () => {
            hideLoader(el);
            tryPlay(el);
          };

          if (el.readyState >= 2) {
            onReady();
          } else {
            el.addEventListener('loadeddata', onReady, { once: true });
            el.addEventListener('canplay', onReady, { once: true });
            el.addEventListener('canplaythrough', onReady, { once: true });
            el.addEventListener('error', () => hideLoader(el), { once: true });
          }

          io.unobserve(el);
        }
      });
    }, { root: scrollRoot, rootMargin: '300px' });

    imgs.forEach(el => {
      const picture = el.closest('picture');
      if (!picture || !picture.classList.contains('priority-image')) {
        io.observe(el);
      }
    });
    iframes.forEach(el => io.observe(el));
    videos.forEach(v => {
      if (!v.classList.contains('priority-video')) io.observe(v);
    });

    // Immediately hydrate & show/hide spinner for above-the-fold media
    requestAnimationFrame(() => {
      imgs.forEach(el => {
        if (inViewport(el)) {
          if (!(el.complete && el.naturalWidth > 0)) showLoader(el);
          if (el.dataset.src && !el.getAttribute('src')) el.setAttribute('src', el.dataset.src);
          if (el.dataset.srcset && !el.getAttribute('srcset')) el.setAttribute('srcset', el.dataset.srcset);
          if (el.complete && el.naturalWidth > 0) hideLoader(el);
          else {
            const done = () => hideLoader(el);
            el.addEventListener('load', done, { once: true });
            el.addEventListener('error', done, { once: true });
          }
        }
      });
      videos.forEach(v => {
        if (inViewport(v) || v.classList.contains('priority-video')) {
          showLoader(v);
          hydrateOnceVideo(v);
          const onReady = () => { hideLoader(v); tryPlay(v); };
          if (v.readyState >= 2) onReady();
          else {
            v.addEventListener('loadeddata', onReady, { once: true });
            v.addEventListener('canplay', onReady, { once: true });
            v.addEventListener('canplaythrough', onReady, { once: true });
            v.addEventListener('error', () => hideLoader(v), { once: true });
          }
        }
      });
    });

    // One-time global "kick" on first user interaction / visibility regain
    let kicked = false;
    function kickAll() {
      if (kicked) return;
      kicked = true;
      videos.forEach(v => { hydrateOnceVideo(v); tryPlay(v); });
    }
    ['touchend','click','keydown','scroll'].forEach(ev =>
      document.addEventListener(ev, kickAll, { once: true, passive: true })
    );
    document.addEventListener('visibilitychange', () => { if (!document.hidden) kickAll(); }, { once: true });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexible-content"] && !Shopify.designMode) return;
  try {
    
  // Sticky Nav
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header-wrapper');
    let lastScrollPosition = window.pageYOffset;
    const scrollThreshold = 300;
    
    window.addEventListener('scroll', function() {
      const currentScrollPosition = window.pageYOffset;
      
      // Only handle fixed/sticky behavior when we're past the threshold
      if (currentScrollPosition > scrollThreshold) {
        
        // Show/hide based on scroll direction
        if (currentScrollPosition < lastScrollPosition) {
          header.classList.add('show-nav');
        } else {
          header.classList.remove('show-nav');
        }
      } else {
        header.classList.remove('show-nav');
      }
      
      lastScrollPosition = currentScrollPosition;
    });
  });
  
  // Parallax Background
  document.addEventListener('DOMContentLoaded', function() {
    const parallaxElement = document.querySelector('.banner-container.parallax');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // When bottom edge crosses viewport
        if (entry.isIntersecting && entry.boundingClientRect.bottom <= window.innerHeight) {
          parallaxElement.classList.add('parallax-visible');
        } else {
          parallaxElement.classList.remove('parallax-visible');
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.25, 0.5, 0.75, 1] // Multiple thresholds to track intersection more precisely
    });
    if (parallaxElement) {
      observer.observe(parallaxElement);
    }
  });

  // Parallax Content
  document.addEventListener('DOMContentLoaded', function() {
    const parallaxContents = document.querySelectorAll('.banner-content-parallax');
    
    if (parallaxContents.length > 0) {
      parallaxContents.forEach(wrapper => {
        let isFixed = false;
        const content = wrapper.querySelector('.banner-content');
        
        window.addEventListener('scroll', () => {
          const rect = wrapper.getBoundingClientRect();
          
          // When top hits viewport top
          if (rect.top <= 0 && !isFixed) {
            wrapper.classList.add('is-visible');
            isFixed = true;
          } 
          // When scrolling back up and content should return to normal flow
          else if (rect.top > 0 && isFixed) {
            wrapper.classList.remove('is-visible');
            isFixed = false;
          }
        });
      });
    }
  });  
  
  // Initialize Swiper for image galleries with slider enabled
  document.addEventListener('DOMContentLoaded', function() {
    const galleries = document.querySelectorAll('.image-gallery.slider');
    galleries.forEach(gallery => {
      new Swiper(gallery.querySelector('.swiper-container'), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          640: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  class SVGLoader extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      const src = this.getAttribute('src');
      try {
        const response = await fetch(src);
        const text = await response.text();
        if (text.includes('<svg')) {
          this.innerHTML = text;
          const svg = this.querySelector('svg');
          svg.setAttribute('width', this.getAttribute('width') || '100%');
          svg.setAttribute('height', this.getAttribute('height') || '100%');
        }
      } catch (error) {
        console.error('Error loading SVG:', error);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);  
  customElements.define('svg-loader', SVGLoader);

  document.addEventListener('DOMContentLoaded', () => {
    const mainHeader = document.querySelector('.header-wrapper');
    const megaMenus = document.querySelectorAll('.mega-menu');
    
    megaMenus.forEach(menu => {
      menu.addEventListener('toggle', () => {
        const isAnyMenuOpen = document.querySelector('.mega-menu[open]');
        if (isAnyMenuOpen) {
          mainHeader.classList.add('nav-open');
        } else {
          mainHeader.classList.remove('nav-open');
        }
      });
    });
  });
  

  } catch(e) { console.error(e); }
})();
})();
